(() => {
  const selector = '[data-wpp-engagement]';
  const root = window.Shopify?.routes?.root || '/';
  const endpoint = `${root}apps/warpath-marketplace/marketplace/engagement`;
  const known = new WeakSet();
  const counters = new Map();
  const viewed = new Set();
  const busy = new Set();
  let browserIdentity;
  let queue = Promise.resolve(),viewQueue=Promise.resolve();
  const likeVersions=new Map();
  let scheduled;
  const bars = (id) => [...document.querySelectorAll(selector)].filter((bar) => bar.dataset.wppEngagement === String(id));
  const enqueue = (work) => { queue = queue.then(work).catch(() => {}); return queue; };

  const enqueueView=work=>{viewQueue=viewQueue.then(work).catch(()=>{});return viewQueue;};

  function sessionId() {
    try {
      const existing = document.cookie.split('; ').find((cookie) => cookie.startsWith('wpp_marketplace_session='))?.split('=')[1];
      if (/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(existing || '')) return existing;
      const id = crypto.randomUUID();
      document.cookie = `wpp_marketplace_session=${id}; Path=/; SameSite=Lax; Secure`;
      return document.cookie.includes(`wpp_marketplace_session=${id}`) ? id : null;
    } catch { return null; }
  }

  function browserId() {
    if (!browserIdentity) {
      const load = () => {
        try {
          const key = 'wpp-marketplace-browser';
          let id = localStorage.getItem(key);
          if (!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id || '')) {
            id = crypto.randomUUID();
            localStorage.setItem(key, id);
          }
          return id;
        } catch { return null; }
      };
      browserIdentity = Promise.resolve(navigator.locks ? navigator.locks.request('wpp-marketplace-browser', load) : load());
    }
    return browserIdentity;
  }

  function render(id) {
    const value = counters.get(String(id));
    for (const bar of bars(id)) {
      if (!value) continue;
      for (const field of ['views', 'likes', 'interested']) {
        bar.querySelector(`[data-count="${field}"]`).textContent = Number(value[field]).toLocaleString(document.documentElement.lang);
      }
      const button = bar.querySelector('[data-engagement-like]');
      if (button) {
        button.disabled = busy.has(String(id)) || typeof value.liked !== 'boolean';
        button.setAttribute('aria-pressed', String(value.liked === true));
        button.querySelector('[aria-hidden]').textContent = value.liked ? '♥' : '♡';
      }
    }
  }

  async function request(ids, mutation) {
    const versions=new Map(ids.map(id=>[String(id),likeVersions.get(String(id))||0]));
    const browser = await browserId();
    const query = new URLSearchParams({ ids: ids.join(',') });
    if (browser) query.set('browser_id', browser);
    const response = await fetch(mutation ? endpoint : `${endpoint}?${query}`, {
      method: mutation ? 'POST' : 'GET',
      credentials: 'same-origin', cache: 'no-store',
      headers: mutation ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      ...(mutation ? { body: JSON.stringify({ ...mutation, ...(browser ? { browser_id: browser } : {}) }) } : {}),
      signal: AbortSignal.timeout(10000),
    });
    const payload = await response.json();
    if (!response.ok || !payload.ok) throw new Error('engagement_unavailable');
    for (const row of payload.counters) {
      const id=String(row.listing_id),previous=counters.get(id);
      if(previous){
        row.views=Math.max(previous.views||0,row.views||0);
        if(mutation?.action==='view'||(!mutation&&(busy.has(id)||versions.get(id)!==(likeVersions.get(id)||0)))){row.likes=previous.likes;row.liked=previous.liked;}
      }
      counters.set(id, row);
      render(row.listing_id);
    }
  }

  function scan() {
    const ids = new Set();
    const views = new Set();
    for (const bar of document.querySelectorAll(selector)) {
      if (known.has(bar)) continue;
      known.add(bar);
      const id = bar.dataset.wppEngagement;
      if (!/^[1-9]\d*$/.test(id)) continue;
      ids.add(id);
      render(id);
      if (bar.hasAttribute('data-record-view') && !viewed.has(id)) views.add(id);
    }
    if (!ids.size) return;
    enqueueView(async () => {
      const list = [...ids];
      for (let i = 0; i < list.length; i += 50) {
        try { await request(list.slice(i, i + 50)); } catch {}
      }
      const session = views.size
        ? await (navigator.locks ? navigator.locks.request('wpp-marketplace-session', sessionId) : sessionId())
        : null;
      for (const id of views) {
        if (!session || viewed.has(id)) continue;
        try {
          await request([id], { action: 'view', listing_id: Number(id), session_id: session });
          viewed.add(id);
        } catch {}
      }
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-engagement-like]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const bar = button.closest(selector);
    const id = bar.dataset.wppEngagement;
    if (busy.has(id)) return;
    const action = counters.get(id)?.liked ? 'unlike' : 'like';
    busy.add(id);likeVersions.set(id,(likeVersions.get(id)||0)+1);
    bars(id).forEach((item) => { item.querySelector('[role="status"]').textContent = ''; });
    render(id);
    enqueue(async () => {
      try { await request([id], { action, listing_id: Number(id) }); }
      catch {
        bars(id).forEach((item) => { item.querySelector('[role="status"]').textContent = item.dataset.error; });
      } finally { busy.delete(id); render(id); }
    });
  });

  document.addEventListener('wpp:marketplace-interest', (event) => {
    const id = String(event.detail?.listingId || '');
    if (/^[1-9]\d*$/.test(id)) enqueue(() => request([id]));
  });
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) {
      clearTimeout(scheduled);
      scheduled = setTimeout(scan, 50);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    const ids = [...new Set([...document.querySelectorAll(selector)].map((bar) => bar.dataset.wppEngagement))];
    enqueue(async () => {
      for (let i = 0; i < ids.length; i += 50) await request(ids.slice(i, i + 50));
    });
  });
  scan();
})();
